<template>
  <div class="fq-wrapper">
    <h1 class="text-center fq-title">Fractions Quiz</h1>

    <!-- Mode selector -->
    <div class="mode-bar text-center">
      <button
        v-for="m in modes"
        :key="m.id"
        class="mode-btn"
        :class="{ 'mode-btn--active': mode === m.id }"
        @click="setMode(m.id)"
      >
        {{ m.label }}
      </button>
    </div>

    <p class="mode-desc text-center">{{ currentModeDesc }}</p>

    <hr class="fq-hr" />

    <app-question
      :key="questionKey"
      :mode="mode"
      @answered="onAnswered"
    ></app-question>
  </div>
</template>

<script>
import Question from "./FractionsQuestion.vue";

const MODES = [
  {
    id: "basics",
    label: "Basics",
    desc: "Compare, simplify & find equivalent fractions.",
  },
  {
    id: "improper",
    label: "Improper Fractions",
    desc: "Identify and convert improper fractions (e.g. 7/4).",
  },
  {
    id: "mixed",
    label: "Mixed Numbers",
    desc: "Convert between improper fractions and mixed numbers (e.g. 1¾).",
  },
  {
    id: "arithmetic",
    label: "Arithmetic",
    desc: "Add, subtract and multiply fractions - answers in simplest form.",
  },
];

export default {
  components: { appQuestion: Question },
  data() {
    return {
      modes: MODES,
      mode: "basics",
      questionKey: 0,
    };
  },
  computed: {
    currentModeDesc() {
      return MODES.find((m) => m.id === this.mode)?.desc ?? "";
    },
  },
  methods: {
    setMode(id) {
      this.mode = id;
      this.questionKey++; // force FractionsQuestion to remount with fresh state
    },
    onAnswered() {},
  },
};
</script>

<style scoped>
.fq-wrapper {
  max-width: 640px;
  margin: 0 auto;
  padding: 24px 16px 60px;
  min-height: 65vh;
}

.fq-title {
  color: rgb(3, 53, 48);
  margin-bottom: 16px;
}

.mode-bar {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.mode-btn {
  border-radius: 20px;
  padding: 5px 18px;
  font-size: 14px;
  cursor: pointer;
  background: transparent;
  color: rgb(3, 53, 48);
  border: 1.5px solid rgb(3, 53, 48);
  transition: all 0.18s;
}
.mode-btn:hover { background: rgb(169, 247, 234); }
.mode-btn--active {
  background: rgb(3, 53, 48);
  color: white;
  border-color: rgb(3, 53, 48);
}

.mode-desc {
  font-size: 14px;
  color: #555;
  min-height: 20px;
  margin-bottom: 6px;
}

.fq-hr {
  border-color: rgba(3, 53, 48, 0.2);
  margin-bottom: 20px;
}
</style>
